import React, { useState } from "react";
import { useEffect } from "react";
import MenuBtns from "./MenuBtns";
import classes from './VerticalMenu.module.css';
import { useSelector } from "react-redux";

const VerticalMenu = ({ children, setCurrentMenuIndex=null, currentIndex, disableOnClick }) => {
    const direction = useSelector(state => state.translate.direction);
    const [currentContentIndexState, setCurrentContentIndexState] = useState(currentIndex)
    const [showCard, setShowCard] = useState(true)

    useEffect(() => {
        setCurrentContentIndexState(currentIndex)
    }, [currentIndex])

    return (
        <div className={`${classes.VerticalMenu} ${classes[direction]}`}>
            <MenuBtns setCurrentMenuIndex ={setCurrentMenuIndex} setCurrentContentIndexState={setCurrentContentIndexState} currentContentIndexState={currentContentIndexState} disableOnClick={disableOnClick}>{children}</MenuBtns>
            {showCard && <div className={classes.ActionCardContainer}>
                <hr className={classes.Line} />
                {children[currentContentIndexState]?.props.children}
            </div>}
        </div>
    )
}

export default VerticalMenu;